import { BrandOptions } from "@/app/(auth)/select-brand/components/BrandAction/type";
import { LoaderContent } from "@/components/Loader/type";

export const toggleSidebar = (payload: boolean) =>
  ({
    type: "TOGGLE_SIDEBAR",
    payload,
  }) as const;
export const toggleModal = (payload: boolean) =>
  ({
    type: "TOGGLE_MODAL",
    payload,
  }) as const;
export const setFormUnsaved = (payload: boolean) =>
  ({
    type: "SET_FORM_UNSAVED",
    payload,
  }) as const;
export const setPendingRoute = (payload: string | null) =>
  ({
    type: "SET_PENDING_ROUTE",
    payload,
  }) as const;
export const setLoading = (payload: boolean) =>
  ({
    type: "SET_LOADING",
    payload,
  }) as const;
export const reset = () =>
  ({
    type: "RESET",
  }) as const;
export const toggleBrand = (payload: { open: boolean; brand: BrandOptions | null }) =>
  ({
    type: "SET_BRAND_TOGGLE_MODAL",
    payload,
  }) as const;
export const toggleTimeoutModal = (payload: boolean, ref?: React.RefObject<HTMLElement | null>) =>
  ({
    type: "TOGGLE_TIMEOUT_MODAL",
    payload,
    ref,
  }) as const;
export const resetReferenceValue = () =>
  ({
    type: "RESET_REFERENCE_VALUE",
  }) as const;
export const setCurrentPageName = (payload?: string) =>
  ({
    type: "SET_CURRENT_PAGE_NAME",
    payload,
  }) as const;
export const setProjectRefinement = (payload: boolean) =>
  ({
    type: "SET_PROJECT_REFINEMENT",
    payload,
  }) as const;
export const toggleImageGenErrorModal = (payload: boolean) =>
  ({
    type: "TOGGLE_IMAGE_GEN_ERROR",
    payload,
  }) as const;
export const setCurrentUserflow = (payload?: string) =>
  ({
    type: "SET_CURRENT_USER_FLOW",
    payload,
  }) as const;
export const setCurrentStepName = (payload?: string) =>
  ({
    type: "SET_CURRENT_STEP_NAME",
    payload,
  }) as const;
export const setIsNewProjectSaved = (payload: boolean) =>
  ({
    type: "SET_IS_NEW_PROJECT_SAVED",
    payload,
  }) as const;
export const setCustomModalContent = (payload: LoaderContent) =>
  ({
    type: "SET_CUSTOM_MODAL_CONTENT",
    payload,
  }) as const;
export const resetCustomModalContent = () =>
  ({
    type: "RESET_CUSTOM_MODAL_CONTENT",
  }) as const;
export const setIsTypeImageAsset = (payload?: boolean) =>
  ({
    type: "IS_IMAGE_TYPE_ASSET",
    payload,
  }) as const;
export const setIsFullyGeneratedImage = (payload?: boolean) =>
  ({
    type: "IS_FULLY_GENERATED_IMAGE",
    payload,
  }) as const;
export const setCancelTrigger = (payload?: boolean) =>
  ({
    type: "SET_CANCEL_TRIGGER",
    payload,
  }) as const;
export const setLinkText = (payload?: string) =>
  ({
    type: "SET_LINK_TEXT",
    payload,
  }) as const;
